/* VDB Product Information 1.7.5 — paginated full compatibility list renderer. */
(function(){
  'use strict';

  const VERSION_RE=/^UK26-V-\d{6}$/;
  let vehicleDataPromise=null;

  function idsFromNode(node){
    const values=String(node?.textContent||'').match(/UK26-V-\d{6}/g)||[];
    return [...new Set(values.filter(v=>VERSION_RE.test(v)))];
  }

  function nextUrlFrom(root){
    const node=root.querySelector('[data-vdb-compatibility-next-url]');
    return node?String(node.getAttribute('data-vdb-compatibility-next-url')||'').trim():'';
  }

  async function idsFrom(root){
    const seen=new Set(idsFromNode(root.querySelector('[data-vdb-compatibility-ids]')));
    let next=nextUrlFrom(root),guard=0;
    while(next&&guard<8){
      guard+=1;
      const response=await fetch(new URL(next,location.origin).toString(),{credentials:'same-origin'});
      if(!response.ok)break;
      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('[data-vdb-product-data]');
      if(!fresh)break;
      idsFromNode(fresh.querySelector('[data-vdb-compatibility-ids]')).forEach(id=>seen.add(id));
      next=nextUrlFrom(fresh);
    }
    return [...seen];
  }

  function loadVehicleData(){
    const existing=window.VDBVEHICLE_DATA;
    if(existing&&existing.schema===2&&existing.catalog==='UK26'&&existing.models&&Array.isArray(existing.strings)) return Promise.resolve(existing);
    if(vehicleDataPromise) return vehicleDataPromise;
    const url=window.VDB_VEHICLE_INDEX_URL;
    if(!url) return Promise.reject(new Error('Vehicle data index is not configured.'));
    vehicleDataPromise=new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src=url;script.async=true;script.dataset.vdbProductVehicleIndex='true';
      script.onload=()=>{
        const data=window.VDBVEHICLE_DATA;
        if(data&&data.schema===2&&data.catalog==='UK26'&&data.models&&Array.isArray(data.strings)) resolve(data);
        else reject(new Error('Vehicle data index could not be validated.'));
      };
      script.onerror=()=>reject(new Error('Vehicle data index could not be loaded.'));
      document.head.appendChild(script);
    }).catch(error=>{vehicleDataPromise=null;throw error;});
    return vehicleDataPromise;
  }

  function modelMeta(){
    const map=new Map();
    const raw=window.VDBMMY_DATA;
    if(!raw||raw.schema!==1||!Array.isArray(raw.makes)) return map;
    raw.makes.forEach(make=>{
      const makeName=String(make[2]||'');
      (make[3]||[]).forEach(model=>{
        const match=String(model[0]||'').match(/(\d+)$/);
        if(match) map.set(String(Number(match[1])),{make:makeName,model:String(model[2]||'')});
      });
    });
    return map;
  }

  function publicRows(data, wantedIds){
    const wanted=new Set(wantedIds);
    const wantedNums=new Set(wantedIds.map(id=>Number(id.slice(-6))));
    const meta=modelMeta();
    const out=[];
    for(const [modelNo,rows] of Object.entries(data.models||{})){
      const mm=meta.get(String(Number(modelNo)))||{make:'',model:''};
      for(const row of rows||[]){
        const n=Number(row[0]);
        if(!wantedNums.has(n)) continue;
        const id='UK26-V-'+String(n).padStart(6,'0');
        if(!wanted.has(id)) continue;
        const type=String(data.strings[row[1]]||'');
        const spec=String(data.strings[row[2]]||'').replace(/^'+/,'').trim();
        const sourceVariant=String(data.strings[row[3]]||'');
        const series=String(data.strings[row[4]]||'').replace(/\s*--\s*/g,' · ').replace(/\s+/g,' ').trim();
        const body=sourceVariant.replace(/^\s*(Plug[- ]?in Hybrid|Mild Hybrid|Electric Motor|Electric|Diesel|Petrol|Hybrid|LPG|CNG)\s+/i,'').trim()||sourceVariant;
        const y1=Number(row[5]),y2=Number(row[6]);
        out.push({id,make:mm.make,model:mm.model,body,series,variant:type,year:y1===y2?String(y1):`${y1}–${y2}`,engine:spec});
      }
    }
    out.sort((a,b)=>a.make.localeCompare(b.make,undefined,{sensitivity:'base'})||a.model.localeCompare(b.model,undefined,{numeric:true,sensitivity:'base'})||a.year.localeCompare(b.year,undefined,{numeric:true})||a.variant.localeCompare(b.variant,undefined,{numeric:true,sensitivity:'base'}));
    return out;
  }

  function cell(text,muted){
    const td=document.createElement('td');td.textContent=text||'';
    if(muted){const span=document.createElement('span');span.className='vdb-muted';span.textContent=muted;td.appendChild(span);}
    return td;
  }

  function setupPager(table,rows){
    const pager=table.querySelector('[data-vdb-pagination]');
    const pageSize=10;let page=1;const pages=Math.max(1,Math.ceil(rows.length/pageSize));
    function pageButtons(){if(pages<=7)return Array.from({length:pages},(_,i)=>i+1);const set=new Set([1,pages,page,page-1,page+1]);return [...set].filter(n=>n>=1&&n<=pages).sort((a,b)=>a-b);}
    function render(){
      rows.forEach((row,i)=>{row.hidden=!(i>=(page-1)*pageSize&&i<page*pageSize);});
      if(!pager)return;pager.innerHTML='';
      if(pages<=1)return;
      const summary=document.createElement('span');summary.className='vdb-compat-pagination__summary';summary.textContent=`Page ${page} of ${pages}`;pager.appendChild(summary);
      const prev=document.createElement('button');prev.type='button';prev.textContent='‹';prev.setAttribute('aria-label','Previous page');prev.disabled=page===1;prev.addEventListener('click',()=>{page--;render();});pager.appendChild(prev);
      const nums=pageButtons();let last=0;
      nums.forEach(n=>{if(last&&n-last>1){const dots=document.createElement('span');dots.textContent='…';pager.appendChild(dots);}const b=document.createElement('button');b.type='button';b.textContent=n;b.classList.toggle('is-active',n===page);b.setAttribute('aria-label',`Page ${n}`);b.addEventListener('click',()=>{page=n;render();});pager.appendChild(b);last=n;});
      const next=document.createElement('button');next.type='button';next.textContent='›';next.setAttribute('aria-label','Next page');next.disabled=page===pages;next.addEventListener('click',()=>{page++;render();});pager.appendChild(next);
    }
    render();
  }

  async function buildCompatibility(root){
    if(root.dataset.vdbCompatibilityReady==='1')return;
    root.dataset.vdbCompatibilityReady='1';
    const wrap=root.querySelector('[data-vdb-compat-table]');
    const tbody=root.querySelector('[data-vdb-compat-body]');
    if(!wrap||!tbody)return;
    const ids=await idsFrom(root);
    if(!ids.length){tbody.innerHTML='<tr><td colspan="6">No compatible vehicle applications have been loaded for this product yet.</td></tr>';return;}
    try{
      const data=await loadVehicleData();
      const records=publicRows(data,ids);
      tbody.innerHTML='';
      records.forEach(v=>{
        const tr=document.createElement('tr');tr.dataset.vdbCompatRow='';
        tr.appendChild(cell(v.make));tr.appendChild(cell(v.model));tr.appendChild(cell(v.body,v.series));tr.appendChild(cell(v.variant));tr.appendChild(cell(v.year));tr.appendChild(cell(v.engine));tbody.appendChild(tr);
      });
      if(!records.length){tbody.innerHTML='<tr><td colspan="6">Compatibility details could not be resolved. Please refresh the page.</td></tr>';return;}
      setupPager(wrap,[...tbody.querySelectorAll('[data-vdb-compat-row]')]);
    }catch(_){
      tbody.innerHTML='<tr><td colspan="6">Compatibility details could not be loaded. Please refresh the page.</td></tr>';
    }
  }

  function init(root){
    if(!root||root.dataset.vdbProductDataReady==='1')return;
    root.dataset.vdbProductDataReady='1';
    const tabs=[...root.querySelectorAll('[data-vdb-tab]')];
    const panels=[...root.querySelectorAll('[data-vdb-panel]')];
    function activate(name,scroll){
      tabs.forEach(btn=>{const on=btn.dataset.vdbTab===name;btn.classList.toggle('is-active',on);btn.setAttribute('aria-selected',on?'true':'false');});
      panels.forEach(panel=>{const on=panel.dataset.vdbPanel===name;panel.hidden=!on;panel.classList.toggle('is-active',on);});
      if(name==='compatibility')buildCompatibility(root);
      if(scroll)root.scrollIntoView({behavior:'smooth',block:'start'});
    }
    tabs.forEach(btn=>btn.addEventListener('click',()=>activate(btn.dataset.vdbTab,false)));
    root._vdbActivate=activate;
  }

  function initAll(){document.querySelectorAll('[data-vdb-product-data]').forEach(init);}
  document.addEventListener('click',function(e){
    const a=e.target.closest('[data-vdb-open-product-info]');if(!a)return;
    const href=a.getAttribute('href');if(!href||href.charAt(0)!=='#')return;
    const root=document.querySelector(href);if(!root)return;
    e.preventDefault();init(root);if(root._vdbActivate)root._vdbActivate('info',true);
  });
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',initAll,{once:true}):initAll();
})();
